import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import WorkRequestHelper from 'app/managecustomer/WorkRequestHelper';
import CustomValidators from '../../../shared/custom-validators';
import { PAGE_TYPES } from '../../../shared/constants';

@Component({
  selector: 'app-components-managecustomer-page-creation-custom-action',
  templateUrl: './page-creation-custom-action.component.html'
})
export class PageCreationCustomActionComponent implements OnInit {
  dfd: any;
  isReadOnly = false;
  isNew = true;
  workRequestDetail: Boo.Objects.Work.SeoMinute.WorkRequestDetail;
  selectedWebsiteUrl: Boo.Objects.WebsiteUrl;
  user: any;

  pageTypes = PAGE_TYPES;
  pageTypeControl: UntypedFormControl;
  notesForContentWriterControl: UntypedFormControl;
  notesForImplementationSpecialistControl: UntypedFormControl;
  formGroup: UntypedFormGroup;

  canActivate?(user: Boo.Objects.User, _partner: Boo.Objects.Partner, params: any): boolean {
    if (params.controlViewModel) {
      params.controlViewModel(this);
    }

    this.dfd = params.parentWindowDfd;
    this.workRequestDetail = params.workRequestDetail;
    this.selectedWebsiteUrl = params.selectedWebsiteUrl;
    this.isReadOnly = !params.canEdit();
    this.isNew = params.isNew;
    this.user = user;
    return true;
  }

  ngOnInit(): void {
    this.setupForm();
  }

  setupForm(): void {
    this.pageTypeControl = new UntypedFormControl(
      (!this.isNew && this.workRequestDetail?.WorkRequest?.KeyValuePairs)
        ? (WorkRequestHelper.getPageType(this.workRequestDetail.WorkRequest)?.trim() || null)
        : null,
      [
        Validators.required
      ]);
    this.notesForContentWriterControl = new UntypedFormControl(
      (!this.isNew && this.workRequestDetail?.WorkRequest?.KeyValuePairs)
        ? (WorkRequestHelper.getNotesForContentWriter(this.workRequestDetail.WorkRequest)?.trim() || null)
        : null,
      [
        Validators.maxLength(3000),
        CustomValidators.cannotContainHTML
      ]);
    this.notesForImplementationSpecialistControl = new UntypedFormControl(
      (!this.isNew && this.workRequestDetail?.WorkRequest?.KeyValuePairs)
        ? (WorkRequestHelper.getNotesForImplementationSpecialist(this.workRequestDetail.WorkRequest)?.trim() || null)
        : null,
      [
        Validators.maxLength(4000),
        CustomValidators.cannotContainHTML
      ]);
    this.formGroup = new UntypedFormGroup({
      pageType: this.pageTypeControl,
      notesForContentWriter: this.notesForContentWriterControl,
      notesForImplementationSpecialist: this.notesForImplementationSpecialistControl
    });
  }

  get selectedUrl(): Boo.Objects.WebsiteUrl {
    return this.selectedWebsiteUrl && this.selectedWebsiteUrl.WebsiteUrlId ? this.selectedWebsiteUrl : null;
  }

  get hasActiveKeyword(): boolean {
    return this.selectedUrl && this.selectedUrl.Keywords.length > 0;
  };

  selectedUrlChanged(newUrl: Boo.Objects.WebsiteUrl): void {
    this.selectedWebsiteUrl = newUrl;
  }

  canSave(): any {
    this.pageTypeControl.markAsDirty();
    this.pageTypeControl.updateValueAndValidity();
    this.notesForContentWriterControl.markAsDirty();
    this.notesForContentWriterControl.updateValueAndValidity();
    this.notesForImplementationSpecialistControl.markAsDirty();
    this.notesForImplementationSpecialistControl.updateValueAndValidity();

    let result = this.formGroup.valid;

    if (!this.hasActiveKeyword) {
      toastr.error('The selected page must have a keyword defined.');
      result = false;
    }

    return result;
  }

  save(workRequest: Boo.Objects.Work.WorkRequest): any {
    WorkRequestHelper.setPageType(workRequest, this.pageTypeControl.value, this.user.UserId);
    WorkRequestHelper.setNotesForContentWriter(workRequest, this.notesForContentWriterControl.value, this.user.UserId);
    WorkRequestHelper.setNotesForImplementationSpecialist(workRequest, this.notesForImplementationSpecialistControl.value, this.user.UserId);
  }
}